import React from 'react';
import { ArrowRight, ShieldCheck, Globe, Zap } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-100" data-id="element-48">
      {/* Final CTA */}
      <div className="py-24 bg-blue-600 relative overflow-hidden" data-id="element-49">
        <div className="absolute inset-0 opacity-10" data-id="element-50">
          <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-51" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3" data-id="element-52" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-53">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-54">
            Ship Paid LLM API Today
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-55">
            Join developers shipping AI products faster. Zero backend code.
            Real-time metered billing.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-56">
            <a href="https://us.posthog.com/external_surveys/019da0fa-860d-0000-f825-d448b1152f42" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-white text-blue-600 px-8 py-4 rounded-xl text-lg font-bold hover:bg-blue-50 transition-all shadow-xl flex items-center justify-center gap-2" data-id="element-57">
              Start Free - No Credit Card <ArrowRight className="w-5 h-5" data-id="element-58" />
            </a>
          </div>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-blue-200" data-id="element-59">
            <span className="flex items-center gap-2" data-id="element-60">
              <Globe className="w-4 h-4" data-id="element-61" /> 5 Continents, 26 PoP locations
            </span>
            <span className="flex items-center gap-2" data-id="element-62">
              <Zap className="w-4 h-4" data-id="element-63" /> Low Latency - &lt;50ms
            </span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-64">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-65">
          <div className="flex items-center gap-2" data-id="element-66">
            <div className="w-6 h-6 bg-blue-600 rounded flex items-center justify-center" data-id="element-67">
              <div className="w-3 h-3 bg-white rounded-sm rotate-45" data-id="element-68" />
            </div>
            <span className="text-lg font-bold text-gray-900" data-id="element-69">
              TokenGates.sh
            </span>
          </div>
          <div className="flex gap-8 text-sm text-gray-500" data-id="element-70">
            <a href="#" className="hover:text-blue-600" data-id="element-71">
              Privacy
            </a>
            <a href="#" className="hover:text-blue-600" data-id="element-72">
              Terms
            </a>
            <a href="#" className="hover:text-blue-600" data-id="element-73">
              Status
            </a>
            <a href="#" className="hover:text-blue-600" data-id="element-74">
              Contact
            </a>
          </div>
          <div className="text-sm text-gray-400" data-id="element-75">
            © 2026 TokenGates.sh. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}